<template>
  <div class="form__input">
    <label
      v-if="label"
      :for="id"
      :class="{ 'label--required': required }"
      class="label label--muted label--semibold"
    >
      {{ label }}
    </label>
    <div
      class="input text-growing"
      :class="{ 'input--disabled': disabled, 'input--errors': allErrors?.length }"
      :data-replicated-value="replicatedValue"
    >
      <textarea
        v-model="model"
        v-bind="$attrs"
        ref="inputRef"
        :id="id"
        :placeholder="disabled ? null : placeholder"
        :disabled="disabled"
        rows="1"
        class="input__field text-growing__field"
        autocomplete="off"
      />
    </div>

    <t-errors :errors="allErrors" />
  </div>
</template>

<script setup>
import { useId, ref, computed, watch } from 'vue'
import { TErrors } from '@shared/ui'
import { useFieldErrors } from '@shared/lib'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  label: String,
  required: { type: Boolean, default: false },
  placeholder: { type: String, default: 'Введите значение' },
  disabled: Boolean,
  errors: Array,
  name: String,
})

const { fieldErrors, clearFieldErrors } = useFieldErrors(props.name)
const allErrors = computed(() => props.errors ?? fieldErrors.value)

const id = useId()
const model = defineModel()
const inputRef = ref(null)
const replicatedValue = computed(() => String(model.value ?? ''))

watch(model, () => { if (fieldErrors.value.length) clearFieldErrors() })

defineExpose({
  focus: () => inputRef.value?.focus(),
  blur: () => inputRef.value?.blur(),
})
</script>
